export default __webpack_public_path__ + "./fonts/trash-light.9cfc56a1f4195d987629e058bce40333.svg";